import { createLoadableDictionaryReducer } from "../loadableStore/loadableReducer";
import { type PriceInfo } from "../../api/pna/PriceInfo";
import { type AvailabilityInfo } from "../../api/pna/AvailabilityInfo";

export const priceReducerData = createLoadableDictionaryReducer<PriceInfo[]>("price");
export const availabilityReducerData = createLoadableDictionaryReducer<AvailabilityInfo>("availability");

export const productsActions = {
  price: priceReducerData.actions,
  availability: availabilityReducerData.actions,
};
